<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon"></span><span class="title-details">基本信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :disabled="!isEdit"
          :showBtn="showBtn"
          ref="form"
        >
        </dynamic-form>
      </div>
      <folded-panel infoName="关联立项">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.contractDetails"
            :enableEdit="editTable.enableEdit"
            :editable="isAdmin"
            :showAdd="isAdmin"
            :edit-rules="validRules"
            :config="{ trigger: 'click', mode: 'cell',autoClearActive:false }"
            :data.sync="tableDatas"
            ref="contractDetails"
            height=""
          >
            <template #projectTypeId="{row}">
              <span>{{row.projectTypeId? row.projectTypeId.code:''}}</span>
            </template>
            <template #projectTypeIdEdit="{row}">
              <data-box
                hostUrl="/projectDelivery"
                :props="{label: 'code',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectTypeId"
                :extendParms="{ searchType:'1' }"
                @confirm="(val) => projectDetail(row,val)"
              ></data-box>
            </template>
            <template #toolbar="scope">
              <div v-if="!isEdit">无</div>
              <el-popover
                :ref="scope.$index + 'a'"
                placement="top"
                width="180"
                v-if="isEdit"
              >
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="$refs[scope.$index + 'a'].doClose()"
                  >取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="delContractDetails(scope.row.id,scope)"
                  >确定
                  </el-button>
                </div>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-delete"
                  slot="reference"
                ></el-button>
              </el-popover>
            </template>
            <template #num="{row}">
              <div>{{row.num?row.num:row.num=1}}</div>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="收款明细">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :enableEdit="editTable.enableEdit"
            :border=true
            :head="editTable.paymentDetails"
            :editable="isEdit"
            :showAdd="isAdmin"
            :config="{ trigger: 'click', mode: 'cell' }"
            :data.sync="tableData1"
            :edit-rules="validRules"
            @blur-active="autoTotals"
            ref="paymentDetails"
            height=""
          >
            <template #moneyId="{row}">
              <div v-for="item in receiptTypes" :key="item.id">
                <div v-if="row.moneyId && row.moneyId.toString() === item.value">{{item.label}}</div>
              </div>
            </template>

          </edit-data-table>
        </div>
      </folded-panel>
      <!-- <folded-panel infoName="时间计划">
        <div slot="content">
          <edit-data-table
            ref="timePlan"
            :showNumber="editTable.showNumber"
            :border=true
            :head="editTable.timePlan"
            :editable="isEdit"
            :showAdd="isEdit"
            :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
            :data.sync="tableData2"
            @blur-active="checkTime"
            height=""
          >
            <template #bsProjectNodeObj="{row}">
              <div>{{row.bsProjectNodeObj ? row.bsProjectNodeObj.name: ''}}</div>
            </template>
            <template #bsProjectNodeObjEdit="{row}">
              <data-box
                hostUrl="/bsProjectNode"
                :props="{label: 'name',value: 'id'}"
                v-model="row.bsProjectNodeObj"
                :tableColumn="dataBoxHead"
                :multiple="false"
                @confirm="(val)=>{row.projectNodeId = val.id}"
              />
            </template>
            <template #keyOuts="{row}">
              <span v-for="(item, index) in row.bsKey0utsList" :key="item.id">{{item.name}}{{index &lt; row.bsKey0utsList.length-1 ? ',' : ''}}</span>
            </template>
            <template #keyOutsEdit="{row}">
              <data-box
                hostUrl="/bsKeyOuts"
                :props="{label: 'name',value: 'id'}"
                v-model="bsKey0utsListArr"
                :tableColumn="dataBoxHead"
                :multiple="true"
                @confirm="(val) => {row.bsKey0utsList = val; const newArr = val.map((item) => { return item.id }); row.keyOutsId = newArr.join()}"
             />
            </template>
            <template #toolbar="scope">
              <div v-if="!isEdit">无</div>
              <el-popover :ref="scope.$index + 'c'" placement="top" width="180" v-if="isEdit">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'c'].doClose()">取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="delTimePlan(scope.row.id,scope)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel> -->
      <!-- <folded-panel infoName="资源计划">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :enableEdit="editTable.enableEdit"
            :border=true
            :head="editTable.resourcePlan"
            :editable="isEdit"
            :showAdd="isEdit"
            :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
            :data.sync="tableData3"
            ref="resourcePlan"
            height=""
          >
            <template #personObj="{row}">
              <div>{{row.personObj ? row.personObj.name: ''}}</div>
            </template>
            <template #personObjEdit="{row}">
              <data-box
                hostUrl="/bs-person/getList"
                :props="{label: 'name',value: 'id'}"
                v-model="row.personObj"
                :tableColumn="dataBoxHead"
                :multiple="false"
                @confirm="val => { row.personId = val.id; row.price = val.rankEntity.settlementUnitPrice }"
                />
            </template>
            <template #projectRolesObj="{row}">
              <div>{{row.projectRolesObj? row.projectRolesObj.name: ''}}</div>
            </template>
            <template #projectRolesObjEdit="{row}">
              <data-box
                hostUrl="/bsProjectRoles"
                 :extendParms="{stakeholderType:'乙方'}"
                :props="{label: 'name',value: 'id'}"
                v-model="row.projectRolesObj"
                :tableColumn="dataBoxHead"
                :multiple="false"
                @confirm="(val)=>{row.projectRolesId = val.id}"
             />
            </template>
            <template #toolbar="scope">
              <div v-if="!isEdit">无</div>
              <el-popover :ref="scope.$index +'d'" placement="top" width="180" v-if="isEdit">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'd'].doClose()">取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="delResourcePlan(scope.row.id,scope)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel> -->
      <folded-panel infoName="附件">
        <div slot="content">
          <el-upload
            v-if="false"
            class="upload-demo"
            :action="actionUrl"
            :headers="uploadHeaders"
            :on-success="handleSuccess"
            :file-list="fileId"
            :show-file-list="true"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-preview="preview"
            style="margin:14px;"
          >
            <el-button size="small" type="primary">附件上传</el-button>
          </el-upload>
          <div class="file-box" v-if="!isEdit" >
            <div v-for="item in fileId" :key='item.id' class="file-item">
              <el-button @click="preview(item)">{{item.name}}</el-button>
              <!-- <i class="el-icon-close file-close" v-if="isEdit" @click="delFile(item,index)"></i> -->
            </div>
          </div>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" v-if="isEdit" :loading="loading" @click="save()">变更确认</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
      <!-- <drag-dialog :show="dialogShow" :title="'审批人选择'" :width="'50%'" @close="close">
        <dynamic-form
          labelWidth="110px"
          :formConfig="dialogForm"
          v-model="form2"
          :showBtn="true"
          :showSaveBtn="false"
          :disabled="false"
          @submit="submitConfirm(2)"
          @cancelForm="dialogShow=false"/>
      </drag-dialog> -->
      <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
    </div>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import DataTableMixin from "@/mixins/DataTableMixin";
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import { findContractById, changeContract, removeContractDetails, removePaymentDetails, removeResourcePlan,
  removeTimePlan, downLoad, delFile,} from "@/api/bill/contract";
import { parseTime } from "@/utils";
import { getDocumentCode } from "@/views/utils";
import initDict from "@/mixin/initDict";
import { getToken } from "@/utils/auth";
import CrudMixin from "@/mixins/CrudMixin";
import DragDialog from "@/components/DragDialog"
import { tableSataus } from '@/views/bill/mixins/status'
// import { billApprovalHr } from "@/api/bill/ProjectPlan";
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";
export default {
  name: "ContractChangeForm",
  components: { FoldedPanel, DataBox,DragDialog,PersonStep },
  mixins: [DataTableMixin, initDict, CrudMixin, tableSataus],
  data() {
    return {
      uploadHeaders: {},
      actionUrl: `${process.env.VUE_APP_BASE_API}/attachment/masterdata/fileUpload`,
      fileList: [],
      bsKey0utsListArr: [],
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "projectName", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      dialogShow: false, // 提交弹窗
      dialogForm: {
        formItemList: []
      },
      tableDatas: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      delLoading: false,
      isEdit: false,
      loading: false,
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "billState",
            label: "立项状态",
            value: "",
            placeholder: "请输入标题",
            span: 8,
            hidden: true,
            disabled: true
          },
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            disabled: true,
            span: 8
          },
          {
            type: "input",
            key: "name",
            label: "名称",
            value: "",
            span: 8,
            disabled: true,
            rules: [
              { required: true, message: "名称不能为空", trigger: "change" }
            ]
          },
          // {
          //   type: "databox",
          //   key: "businessId",
          //   label: "商机",
          //    disabled: true,
          //   span: 8,
          //    props: {
          //     label: 'name',
          //     value: ''
          //   },
          //   url: '/bs-person/getList',
          //   tableColumn: [
          //     {
          //       property: "number",
          //       label: "编码",
          //       query: {
          //         type: 'input'
          //       }
          //     },
          //     {
          //       property: "name",
          //       label: "名称",
          //       query: {
          //         type: 'input'
          //       }
          //     }
          //   ],
          //   extendParms: {queryFieldItem: 'id,number,name'},
          //   multiple: false,
          // },
          {
            type: 'text',
            label: '合同号',
            key: 'businessId',
            span: 8,
            disabled: true
          },
          /* {
            label: "经营人",
            key: "personManage",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: [
              { required: true, message: "经营人不能为空", trigger: "change" }
            ]
          }, */
          // {
          //   label: '商机所有人',
          //   key: 'personBusiness',
          //   type: 'databox',
          //   disabled: true,
          //   span: 8,
          //   props: {
          //     label: 'name',
          //     value: ''
          //   },
          //   url: '/bs-person/getList',
          //   tableColumn: [
          //     {
          //       property: "number",
          //       label: "编码",
          //       query: {
          //         type: 'input'
          //       }
          //     },
          //     {
          //       property: "name",
          //       label: "名称",
          //       query: {
          //         type: 'input'
          //       }
          //     }
          //   ],
          //   extendParms: {queryFieldItem: 'id,number,name'},
          //   multiple: false,
          // },
          {
            label: "项目负责人",
            key: "personLeader",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: [
              { required: true, message: "项目负责人不能为空", trigger: "change" }
            ]
          },
          {
            type: "inputNumber",
            key: "subContractAmount",
            label: "子项目合同金额",
            placeholder: "请输入子项目合同金额",
            span: 8,
            min: 0,
            controls: false,
            precision: 2,
          },
          {
            label: "项目经理",
            key: "personSell",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: [
              { required: true, message: "项目经理不能为空", trigger: "change" }
            ]
          },
          /* {
            type: "inputNumber",
            key: "contractDiscount",
            label: "合同折扣率",
            placeholder: "请输入合同折扣率",
            span: 8,
            min: 0,
            max: 100,
            controlsPosition: 'right',
            precision: 2,
            rules: [
              { required: true, message: "合同折扣率不能为空", trigger: "blur" }
            ]
          }, */
          // {
          //   type: "input",
          //   key: "topicId",
          //   label: "关联立项",
          //   value: "",
          //   placeholder: "请输入标题",
          //   span: 8,
          //   disabled: true,
          // },
          // {
          //   span: 8,
          //   type: "radio",
          //   label: "签约状态",
          //   value: 0,
          //   button: false,
          //   border: false,
          //   key: "state",
          //   disabled: true,
          //   options: [
          //     {
          //       value: 1,
          //       label: "已签约",
          //     },
          //     {
          //       value: 0,
          //       label: "未签约",
          //     }
          //   ],
          // },
          {
            label: "终端客户",
            key: "customerMain",
            type: "databox",
            span: 8,
            disabled: true,
            props: {
              label: "name",
              value: "id"
            },
            url: "/customer",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: [
              { required: true, message: "终端客户不能为空", trigger: "change" }
            ]
          },
          {
            label: "签约客户",
            key: "customerSigning",
            type: "databox",
            span: 8,
            disabled: true,
            props: {
              label: "name",
              value: "id"
            },
            url: "/customer",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: [
              { required: true, message: "签约客户不能为空", trigger: "change" }
            ]
          },
          {
            type: "number",
            key: "totals",
            label: "合同总金额",
            disabled: true,
            value: "",
            span: 8
          },
          {
            type: "select",
            label: "合同类型",
            key: "contractType",
            span: 8,
            options: [],
            disabled: true,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          {
            type: "radio",
            label: "合同类别",
            key: "category",
            span: 8,
            options: [
              {
                label: '交付合同',
                value: 'D'
              },
              {
                label: '管理人天合同',
                value: 'M'
              }
            ],
            rules: [{
              required: false,
              message: "合同类别不能为空",
              trigger: "change"
            }]
          },
          // {
          //   type: "upload",
          //   key: "annexId",
          //   label: "附件",
          //   uploadUrl: `${process.env.VUE_APP_BASE_API}/attachment/masterdata/fileUpload`,
          //   value: "",
          //   span: 8,
          // },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            disabled: true,
            placeholder: "请输入标题",
            span: 24,
            maxlength: 200
          }
        ]
      },
      showBtn: false,
      openLook: false,
      form: {},
      editTable: {
        showNumber: true,
        enableEdit: true,
        showAdd: true,
        contractDetails: [
          {
            label: "立项编码",
            prop: "projectTypeId",
            editRender: {
              type: "default"
            }
          },
          {
            label: "项目号",
            prop: "projectCode",
            editRender: {
              type: "default",
              name: "ElInput",
              props: { disabled: true }
            }
          },
          {
            label: "项目名称",
            prop: "projectName",
            editRender: {
              type: "default",
              name: "ElInput",
              props: { disabled: true }
            }
          }
        ],
        paymentDetails: [
          {
            label: "款项说明",
            prop: "moneyId",
            editRender: {
              type: "default",
              name: "ElSelect",
              options: []
            }
          },
          {
            label: "金额",
            prop: "totals",
            editRender: { type: "default", name: "ElInput" }
          },
          {
            label: "已收金额",
            prop: "receivedMoney",
            editRender: {
              type: "default",
              name: "ElInput",
              props: { disabled: true }
            }
          },
          {
            label: "未收金额",
            prop: "uncollectedMoney",
            editRender: {
              type: "default",
              name: "ElInput",
              props: { disabled: true }
            },
            formatter: (val, row) => {
              const value = parseInt(row.totals) - parseInt(row.receivedMoney ? row.receivedMoney : 0);
              row.uncollectedMoney = value;
              return value || 0
            }
          },
          {
            label: "付款条件",
            prop: "conditions",
            editRender: { type: "default", name: "ElInput" }
          },
          {
            label: "备注",
            prop: "remark",
            editRender: { type: "default", name: "ElInput" }
          }
        ],
        timePlan: [
          {
            label: "项目节点",
            prop: "bsProjectNodeObj",
            editRender: { type: "default" }
          },
          {
            label: "计划开始日期",
            prop: "startDate",
            formatter: this.formatter,
            editRender: {
              name: "ElDatePicker",
              props: { type: "date", valueFormat: "timestamp" }
            }
          },
          {
            label: "计划完成日期",
            prop: "endDate",
            formatter: this.formatter,
            editRender: {
              name: "ElDatePicker",
              props: { type: "date", valueFormat: "timestamp" }
            }
          },
          {
            label: "关键输出物",
            prop: "keyOuts",
            editRender: { type: "default" }
          },
          {
            label: "收款",
            prop: "receivables",
            formatter: this.receiveFormatter,
            editRender: {
              type: "default",
              name: "ElSelect",
              options: [
                {
                  value: 0,
                  label: "未收款"
                },
                {
                  value: 1,
                  label: "已收款"
                }
              ]
            }
          },
          {
            label: "备注",
            prop: "remark",
            editRender: { type: "default", name: "ElInput" }
          }
        ],
        resourcePlan: [
          {
            label: "人员",
            prop: "personObj",
            editRender: { type: "default" }
          },
          {
            label: "项目角色",
            prop: "projectRolesObj",
            editRender: { type: "default" }
          },
          {
            label: "人天",
            prop: "days",
            editRender: { type: "default", name: "ElInputNumber" }
          },
          {
            label: "单价",
            prop: "price"
          },
          {
            label: "备注",
            prop: "remark",
            editRender: { type: "default", name: "ElInput" }
          }
        ]
      },
      fileId: [],
      validRules: {
        totals: [
          {
            required: true,
            pattern: /^\d+\.?(\d{1,2})?$/,
            message: "小数点后保留两位",
            trigger: "change"
          }
        ],
        moneyId: [{ required: true, message: "不能为空", trigger: "blur" }],
        projectTypeId: [
          { required: true, message: "不能为空", trigger: "blur" }
        ]
        //    receivedMoney: [{
        //             validator(rule, value, callback) {
        //               const reg = /^\d+\.?(\d{1,2})?$/
        //               if (reg.test(value)) {
        //                 callback();
        //               } else {
        //                 callback(new Error("小数点后保留两位"));
        //               }
        //             },
        //             trigger: "change"
        //           }],
        //  uncollectedMoney: [{
        //           validator(rule, value, callback) {
        //             const reg = /^\d+\.?(\d{1,2})?$/
        //             if (reg.test(value)) {
        //               callback();
        //             } else {
        //               callback(new Error("小数点后保留两位"));
        //             }
        //           },
        //           trigger: "blur"
        //         }],
      },
      receiptTypes: [], // 收款方式
      validatedRefNames: ["form", "paymentDetails", "contractDetails"],
      form2: {}, // hr审批
      assignData: {}, // hr审批人员信息
      stepShow: false,
      personStepData: []
    };
  },
  watch: {
    "form.customerMain": {
      // 客户主体带出签约客户
      handler(val) {
        if (val && !this.form.customerSigning) {
          this.form.customerSigning = {
            id: val.id,
            name: val.name,
            code: val.code
          };
          // this.$set(this.form.customerSigning,'id', val.id)
          // this.$set(this.form.customerSigning,'name', val.name)
        }
      }
    },
    tableData1: {
      handler(val) {
        let sum = 0;
        val.forEach(ele => {
          sum += Number(ele.totals);
        });
        this.form.totals = sum.toFixed(2);
      },
      deep: true
    }
  },
  created() {
    console.log(this.$route)
    this.uploadHeaders = { Authorization: `Bearer ${getToken()}` };
    this.initData();
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    // 款项说明
    this.getDict("RECEIPT").then(res => {
      // this.editTable.paymentDetails[0].editRender.options = res.data;
      this.$set(
        this.editTable.paymentDetails[
          this.editTable.paymentDetails.findIndex(ele => ele.prop === "moneyId")
        ].editRender,
        "options",
        res.data
      );
      this.receiptTypes = res.data;
    });

     // 合同类型
    this.getDict("contractType").then(res => {
      this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'contractType')].options = res.data;
    });
  },
  methods: {
    // 上传成功回调
    handleSuccess(res) {
      if (res.code === 200) {
        this.$notify({ title: "上传成功！", type: "success", duration: 1500 });
        this.fileId.push(res.data);
      }
    },
    // 下载文件
    preview(file) {
      console.log(file);
      downLoad(file.id, file.name);
    },
    beforeRemove(file, fileList) {
      // if (!this.isEdit) {
      //   return this.$notify({ title: "查看页面不能进行删除", type: "error", duration: 1500 });
      // }
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 删除文件
    handleRemove(file, fileList) {
      delFile(file.id).then(res => {
        this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
        this.fileId = fileList;
      });
    },
    receiveFormatter(val) {
      if (val === 0) {
        return "未收款";
      } else if (val === 1) {
        return "已收款";
      } else {
        return "";
      }
    },
    projectDetail(row, val) {
      row.projectTypeId = val;
      row.deliveryCode = val.code;
      row.projectCode = val.bsProject.code;
      row.projectName = val.bsProject.name;
      row.deliveryId = val.id;
      row.contractId = this.id;
    },
    checkTime(row) {
      if (row.startDate && row.endDate) {
        if (row.startDate > row.endDate) {
          this.$message.warning("计划开始日期不能大于计划结束日期！");
          row.startDate = "";
          row.endDate = "";
        }
      }
    },
    autoTotals(row) {
      // this.form.totals = Number(this.form.totals) + Number(row.totals)
      // if (row.price && row.num) {
      //   row.totals = Number(row.price) * Number(row.num)
      // }
      // this.getTotals()
    },
    // 计算总金额
    getTotals() {
      // this.form.totals = this.tableData1.reduce((pre, cur) => {
      //   return cur.totals + pre
      // }, 0)
    },
    formatter(val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    delContractDetails(id, scope) {
      if (!id) {
        this.$refs.contractDetails.deleteRows(scope.row);
        this.getTotals();
        return;
      }
      removeContractDetails(id).then(res => {
        if (res.code === 200) {
          this.$refs[scope.$index + "a"].doClose();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
          this.tableDatas.splice(scope.$index, 1);
          this.getTotals();
        }
      });
    },
    delPaymentDetails(id, scope) {
      if (!id) {
        this.$refs.paymentDetails.deleteRows(scope.row);
        this.$refs[scope.$index + "b"].doClose();
        return;
      }
      removePaymentDetails(id).then(res => {
        if (res.code === 200) {
          this.$refs[scope.$index + "b"].doClose();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
          this.tableData1.splice(scope.$index, 1);
        }
      });
    },
    delTimePlan(id, scope) {
      if (!id) {
        this.$refs.timePlan.deleteRows(scope.row);
        return;
      }
      removeTimePlan(id).then(res => {
        if (res.code === 200) {
          this.$refs[scope.$index + "c"].doClose();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
          this.tableData2.splice(scope.$index, 1);
        }
      });
    },
    delResourcePlan(id, scope) {
      if (!id) {
        this.$refs.resourcePlan.deleteRows(scope.row);
        return;
      }
      removeResourcePlan(id).then(res => {
        if (res.code === 200) {
          this.$refs[scope.$index + "d"].doClose();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
          this.tableData3.splice(scope.$index, 1);
        }
      });
    },
    async initData() {
      if (!this.$route.params.id) {
        this.form.code = getDocumentCode("HT");
        return;
      }
      const result = await findContractById(this.$route.params.id);
      this.form = result.data.bizContract;
      result.data.bizTimePlans.forEach(item => {
        item.bsProjectNodeObj = item.bsProjectNode;
      });
      result.data.bizResourcePlannings.forEach(item => {
        item.personObj = item.person;
        item.projectRolesObj = item.projectRoles;
      });
      this.tableDatas = result.data.contractDeliveryList;
      this.tableDatas.forEach(ele => {
        ele.projectTypeId = { code: ele.deliveryCode, id: ele.deliveryId };
      });
      this.tableData1 = result.data.bizPaymentDetails;
      this.tableData2 = result.data.bizTimePlans;
      this.tableData3 = result.data.bizResourcePlannings;
      this.fileId = result.data.attachmentIds;
    },
    // 校验总金额
    checkAmount() {
      const payTotals = this.tableData1.reduce((pre, cur) => {
        return cur.totals + pre;
      }, 0);
      if (this.form.totals === payTotals) {
        return 1;
      } else {
        return 0;
      }
    },
    // 组装表单数据
    getFormData() {
      // if (!this.checkAmount()) {
      //   this.$message.warning("付款明细总金额与合同总金额不一致！")
      //   return
      // }
      if (this.form.personManage) {
        this.form.personManageId = this.form.personManage.id
          ? this.form.personManage.id
          : this.form.personManageId;
      }
      if (this.form.personLeader) {
        this.form.personLeaderId = this.form.personLeader.id
          ? this.form.personLeader.id
          : this.form.personLeaderId;
      }
      if (this.form.personBusiness) {
        this.form.personBusinessId = this.form.personBusiness.id
          ? this.form.personBusiness.id
          : this.form.personBusinessId;
      }
      if (this.form.personSell) {
        this.form.personSaleId = this.form.personSell.id
          ? this.form.personSell.id
          : this.form.personSaleId;
      }
      if (this.form.customerMain) {
        this.form.customerMainId = this.form.customerMain.id
          ? this.form.customerMain.id
          : this.form.customerMainId;
      }
      if (this.form.customerSigning) {
        this.form.customerSigningId = this.form.customerSigning.id
          ? this.form.customerSigning.id
          : this.form.customerSigningId;
      }
      const obj = {};
      obj.bizContract = this.form;
       if (status === 2) { // HR审批提交人信息
        obj.from = "contract"
        // obj.assignData = JSON.stringify(this.assignData)
      }
      obj.contractDeliveryList = this.tableDatas;
      obj.bizPaymentDetails = this.tableData1;
      obj.bizTimePlans = this.tableData2;
      obj.bizResourcePlannings = this.tableData3;
      obj.attachmentIds = this.fileId;
      return obj;
    },
    pull(obj) {
      if (this.form.id) {
        changeContract(obj).then(res => {
          this.loading = false;
          if (res.code === 200) {
            this.$notify({
              title: "操作成功",
              type: "success",
              duration: 2500
            });
            this.cancel()
          }
        });
      }
    },
     close() {
      this.stepShow = false;
    },
    // 保存
    save() {
       this.loading = true;
        this.pull(this.getFormData());
    },
    submitConfirm(val) {
       this.loading = true;
      const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      this.pull(obj)
    },
    // 提交
    submit(status) {
      this.loading = true;
      this._validateForm(this.validatedRefNames).then(() => {
      // this.pull(this.getFormData(status))
      getFlowNode({ from: "contract", id: this.form.id, contractDiscount: this.form.contractDiscount }).then(res => {
         this.loading = false;
          this.personStepData = [];
          if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
          }
        });
      }).catch(e => { this.loading = false; })
    },
    cancel() {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
// @import '@/views/bill/mixins/common.scss'
.app-container {
  .file-box {
    margin-top: 10px;
    display: flex;
    position: relative;
    padding: 10px;
    .file-item {
      position: relative;
      margin-right: 14px;
      .file-close {
        position: absolute;
        left: 0px;
        top: -6px;
        font-size: 14px;
      }
    }
  }
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    border-radius: 10px;

    .content-title {
      height: 40px;
      background-color: #e7eff6;
      padding-left: 20px;
      overflow: hidden;

      .title-icon {
        display: inline-block;
        margin-top: 8px;
        width: 6px;
        height: 24px;
        background-color: #1369a8;
        margin-right: 14px;
      }

      .title-details {
        overflow: hidden;
        line-height: 20px;
        display: inline-block;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-family: SourceHanSansSC-regular;
      }
    }

    .button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
  }
}
</style>
